import React from 'react'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { InputAdornment } from '@mui/material'

const EstimatedWeight = ({ moduleValues, setModuleValues }) => (
  <Grid item xs={12} lg={4}>
    <TextField
      fullWidth
      label="Estimated Weight"
      value={moduleValues['Estimated Weight'] ?? ''}
      onChange={(e) =>
        setModuleValues((prev) => ({
          ...prev,
          ['Estimated Weight']: e.target.value,
        }))
      }
      InputProps={{
        endAdornment: <InputAdornment position="end">kg</InputAdornment>,
      }}
    />
  </Grid>
)

export default EstimatedWeight
